<template>
    <div class="box">
        <el-container>
            <el-header>
                <headerList></headerList>
            </el-header>
            <el-main>
                <div class="pic">
                    <el-carousel trigger="click" height="42.8125rem">
                        <el-image fit="fill"
                                style="width: 100%; height: 100%; vertical-align: middle"
                                :src="require('@/assets/image/banner1.png')"
                        ></el-image>
                    </el-carousel>
                </div>
                <div class="tab">
                    <div class="public jjyl">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">居家养老服务</div>
                        <a href="#service" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class=" public yljg">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">养老机构预约</div>
                        <a href="#home" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class="public gzsq">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">适老化改造申请</div>
                        <a href="#apply" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class="public jtcw">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">家庭照护床位申请</div>
                        <a href="#bed" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class="public ylzx">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">养老资讯</div>
                        <a href="#provide" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class="public pxxx">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">培训学习</div>
                        <a href="#study" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                    <div class="public zyz">
                        <div class="jjyl-pic "></div>
                        <div class="jjyl-text">志愿者服务</div>
                        <a href="#advantages" style="display: block;width:100%;height:100%;position: relative;top:-9rem;left:0;z-index: 99"></a>
                    </div>
                </div>
                <div class="service" id="service"  v-if='homeData'>
                    <a name=""></a>
                    <div class="service-title">
                        <div class="title-top" v-html='homeData.title'></div>
                        <div class="title-bottom">HOME BASED CARE SERVICE</div>
                    </div>
                    <div class="service-pic">
                        <el-carousel
                                trigger="click"
                                :interval="4000"
                                type="card"
                                height="30.6875rem"
                        >
                            <el-carousel-item v-for="item in homeData.imgList" :key="item">
                                <!-- <h3 class="small">{{ item }}</h3> -->
                                <el-image fit="cover"
                                        style="width: 100%; height: 100%; vertical-align: middle"
                                        :src="imgUrl+item"
                                ></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="service-content" v-html='homeData.represent'>
                            
                        </div>
                        <!-- <div class='appointment'> -->
                        <el-button class="appointment" type="warning" round @click="appointment(1)"
                        >立即预约 →</el-button
                        >
                        <!-- </div> -->
                    </div>
                </div>
                <div class="process" id="process">
                    <!--          <a name="process"></a>-->
                    <div class="service-title">
                        <div class="title-top">服务流程</div>
                        <div class="title-bottom">Service process</div>
                    </div>
                    <div class="process-content">
                        <div v-for="item in 5" class="process-list">
                            <img fit="cover"
                                    :src="require('@/assets/image/service' + item + '.jpg')"
                                    alt=""
                                    class="process-pic"
                            />
                        </div>
                    </div>
                    <!-- <div class="process-bottom">
                      <div class="process-line" v-for="item in 5">
                        <div class="line" :class="{ isactive: flag }"></div>
                        <div class="yuan" :class="{ isactive: flag }"></div>
                        <div class="process-text" :class="{ 'isactive-text': flag }">
                          STEP1
                        </div>
                      </div>
                    </div> -->
                </div>
                <div class="home" id="home" v-if='appointmenData'>
                    <div class="service-title">
                        <div class="title-top" v-html='appointmenData.title'></div>
                        <div class="title-bottom">Appointment of nursing home</div>
                    </div>
                    <div class="home-content">
                        <div class="home-pic">
                            <el-image fit="cover"
                                      style="width: 21.1875rem; height: 21.625rem; vertical-align: middle"
                                      :src="imgUrl+ appointmenData.imgList[0]"
                            ></el-image>
                            <el-image fit="cover"
                                      style="width: 24.5rem; height: 21.625rem; vertical-align: middle"
                                      :src="imgUrl+ appointmenData.imgList[1]"
                            ></el-image>
                            <el-image fit="cover"
                                      style="
                  width: 36.5rem;
                  height: 21.625rem;
                  vertical-align: middle;
                  opacity: 0.6;
                "
                                     :src="imgUrl+ appointmenData.imgList[2]"
                            ></el-image>
                        </div>
                        <div class="home-bottom">
                            <div class="home-left">
                                <div class="home-text" v-html='appointmenData.represent'>
                                    养老机构包括公建民营敬老院及医养结合护理院，集医疗、护理、养老为一体全生命周期服务模式，即为老人进行常规的护理服务的同时，提供24小时全程精心的生活照料和情感浓厚的人文关怀，服务呈现多样化、细致化、特色化、人性化。
                                </div>
                                <!-- <div class="home-btn"> -->
                                <el-button class="home-btn" type="warning" round @click="organization()"
                                >立即预约 →</el-button
                                >
                                <!-- </div> -->
                            </div>
                            <el-image fit="cover"
                                      style="width: 18.25rem; height: 19.125rem; vertical-align: middle"
                                      :src="imgUrl+ appointmenData.imgList[3]"
                            ></el-image>
                            <el-image fit="cover"
                                      style="width: 18.25rem; height: 19.125rem; vertical-align: middle"
                                      :src="imgUrl+ appointmenData.imgList[4]"
                            ></el-image>
                        </div>
                    </div>
                </div>
                <div class="apply" id="apply" v-if='modificationData'>
                    <div class="service-title" style="color: #fff">
                        <div class="title-top" v-html='modificationData.title'></div>
                        <div class="title-bottom">Application for aging modification</div>
                    </div>
                    <div class="service-content">
                        <div class="service-content" style="color: #fff" v-html='modificationData.represent'>
                          
                        </div>
                        <!-- <div class='appointment'> -->
                        <el-button class="apply-btn" type="warning" round  @click="appointment(3)"
                        >立即预约 →</el-button
                        >
                    </div>
                </div>
                <div class="apply-pic" >
                    <el-carousel trigger="click" :interval="0" type="card" height="18.0625rem">
                        <el-carousel-item v-for="item in modificationData.imgList" :key="item">
                            <!-- <h3 class="small">{{ item }}</h3> -->
                            <el-image fit="cover"
                                    style="width: 100%; height: 100%; vertical-align: middle"
                                    :src="imgUrl+item"
                            ></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="bed" id="bed" v-if='bedData'>
                    <div class="service-title">
                        <div class="title-top" v-html='bedData.title'></div>
                        <div class="title-bottom">Application for home care bed</div>
                    </div>
                    <div class="bed-pic">
                        <el-carousel
                                trigger="click"
                                :interval="0"
                                type="card"
                                height="35.5rem"
                        >
                            <el-carousel-item v-for="item in bedData.imgList" :key="item">
                                <!-- <h3 class="small">{{ item }}</h3> -->
                                <el-image fit="fill"
                                        style="width: 100%; height: 100%; vertical-align: middle"
                                        :src="imgUrl+item"
                                ></el-image>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="bed-text" v-html='bedData.represent'>
                      
                    </div>
                    <el-button class="bed-btn" type="warning" @click="appointment(4)" round>立即预约 →</el-button>
                </div>
                <div class="provide" id="provide">
                    <div class="service-title">
                        <div class="title-top">养老资讯</div>
                        <div class="title-bottom">news of provide for the aged</div>
                    </div>
                    <div class="more-list" @click="provideList()">查看更多>></div>
                    <div class="provide-content">
                        <div class="provide-list" v-for="item in topNews" @click='provide(item)'>
                            <div class="provide-pic" >
                                <img
                                        :src="imgUrl+item.img"
                                        alt=""
                                        style="width: 100%; height: 100%"
                                />
                            </div>
                            <div class="provide-date">
<!--                                <div class="provide-day">6-25</div>-->
                                <div class="provide-year" v-html='updateTime(item.created)'></div>
                            </div>
                            <div class="provide-title">{{item.title}}</div>
                            <div class="provide-text" v-html='item.content'>

                            </div>
                        </div>
                    </div>
                    <div class="provide-news">
                        <div class="news-content" v-for="item in newsList"  @click='provide(item)'>
                            <div class="news-date" v-html='updateTime(item.created)'></div>
                            <div class="news-text">
                                {{item.title}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="study" id="study">
                    <div class="service-title">
                        <div class="title-top">培训学习</div>
                        <div class="title-bottom">Training and learning</div>
                    </div>
                    <div class="more-study" @click="consult()">查看更多>></div>
                    <div class="study-content">
                        <div class="study-pic" v-for="item in videoList"  @click="openVideo(item)">
                            <el-image fit="cover"
                                    style="width: 100%; height: 11rem; vertical-align: middle"
                                    :src="require('@/assets/image/study1.jpg')"
                            ></el-image>
                            <div class="study-date">{{item.title}}<div style="float:right;font-size: 12px;" v-html='updateTime(item.created)'></div></div>
                            <div class="study-title">
                                {{item.tdescribe}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="advantages" id="advantages">
                    <div class="service-title">
                        <div class="title-top">服务优势</div>
                        <div class="title-bottom">Service advantages</div>
                    </div>
                    <div class="advantages-content">
                        <div class='advantages-pic' v-for="item in advantage" @click='volunteer()'>
                            <el-image fit="cover"
                                    style="width: 100%; height: 18.75rem; vertical-align: middle"
                                    :src="require('@/assets/image/advantages'+item.label+'.jpg')"
                            ></el-image>
                            <div class='advantages-box'>
                                <div class='advantages-title'>
                                    服务优势
                                </div>
                                <div class='advantages-text'>
                                    {{item.content}}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </el-main>
            <div class="menu" v-if="showMenu">
                <ul>
                    <li class="menu-item-service" @click="openChart()"></li>
                    <li class="menu-item-tel">
                        <el-popover
                                placement="left"
                                title="联系电话"
                                width="200"
                                trigger="hover"
                                content="952183">
                            <div slot="reference" style="width:100%;height:100%"></div>
                        </el-popover>
                    </li>
                    <li class="menu-item-wechat">
                        <el-popover
                                placement="left"
                                title=""
                                width="200"
                                trigger="hover"
                                content="952183">
                            <div>
                                <el-image fit="cover"
                                          style="width: 100%; height: 12rem; vertical-align: middle"
                                          :src="require('@/assets/image/wechat.jpg')"
                                ></el-image>
                            </div>
                            <div slot="reference" style="width:100%;height:100%"></div>
                        </el-popover>
                    </li>
                    <li class="menu-item-message" @click="message(4)"></li>
                </ul>
            </div>
            <div>
                <chart v-if="showFlag == true"></chart>
            </div>
        </el-container>
    </div>
</template>

<script>
    import headerList from "./public/header";
    import chart from "./public/chart";
    export default {
        name: "website",
        components: { headerList,chart },
        data() {
            return {
                userInfo: {
                    id: "",
                    username: "7777",
                    avatar: "",
                },
                username: "",
                showMenu: false,
                wordtop: 0,
                flag: false,
                imgUrl:'http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/',
                url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
                videoList:[],
                topNews:[],
                newsList:[],
                websock: null,
                showFlag:false,
                homeData:'',//居家数据
                appointmenData:'',//机构数据
                modificationData:'',//适老化数据
                bedData:'',//家庭床位数据
                advantage:[
                    {label:1,content:'居家老人、社区及养老机构的传感网系统与信息平台,并在此基础上提供物联化、互联化、智能化的养老服务'},
                    {label:2,content:'老人的身体状况进行跟踪监测,并对异常情况及时告警,保障老人的居家安全'},
                    {label:3,content:'养老照护、智慧健康养老以及护理照料等老年用品和服务'},
                    {label:4,content:'发展“互联网+养老服务”“互联网+老年健康服务”,更好发挥信息科技赋能作用'},
                    {label:5,content:'专业安全体系、体系化信息技术和场景化用户服务经验'},
                ]

            };
        },
        created() {
            const userInfo = localStorage.getItem("userInfo");
            if (userInfo != null) {
                this.userInfo = JSON.parse(userInfo);
            }
            // this.getUserInfo()
            this.getVido();
            this.getNew();
            this.getTopNew();
            this.getHomePage();
        },
        mounted() {
            // this.username = this.$route.params.username;
            window.addEventListener("scroll", this.handleScroll);
        },
        methods: {
            updateTime(item){
                let newList= item.split("T");
            return newList[0]
            },
            handleScroll: function () {
                if (document.body.scrollTop != 0) {
                    this.wordtop = document.body.scrollTop;
                } else {
                    this.wordtop = document.documentElement.scrollTop;
                }
                if (this.wordtop > 800) {
                    this.showMenu = true;
                } else {
                    this.showMenu = false;
                }
            },
            beforeDestroy() {
                window.removeEventListener("scroll", this.handleScroll);
            },
            logout() {
                this.$axios.post("/logout").then((res) => {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$store.commit("resetState");
                    this.$router.push({
                        path: "/login",
                        name: "Login",
                        params: {
                            activeName: "first",
                        },
                    });
                });
            },
            login() {
                this.$router.push({
                    path: "/login",
                    name: "Login",
                    params: {
                        activeName: "first",
                    },
                });
            },
            organization(){
                if(this.userInfo.id == ''){
                    this.$message({
                        message: '请先登录',
                        type: 'warning'
                    });
                    return;
                }
                if(this.userInfo.role != 3){
                     this.$message({
                        message: '管理员无预约权限',
                        type: 'warning'
                    });
                    return;
                }
                //养老机构
                this.$router.push("/organization");
            },
            provide(item) {
                //养老资讯
                 //资讯详情
                this.$router.push({
                    name:'information',
                    // path:'/serviceList',
                    query: item
                });
            },
            provideList(){
                //资讯详情
                // if(this.userInfo.id == ''){
                //     this.$message({
                //         message: '请先登录',
                //         type: 'warning'
                //     });
                //     return;
                // }
                this.$router.push({
                    name:'provide',
                    // path:'/serviceList',
                    query: ''
                });
            },
            volunteer() {
                //志愿者服务
                this.$router.push("/volunteer");
            },
            consult() {
                // if(this.userInfo.id == ''){
                //     this.$message({
                //         message: '请先登录',
                //         type: 'warning'
                //     });
                //     return;
                // }
                // if(this.userInfo.role != 3){
                //      this.$message({
                //         message: '管理员无预约权限',
                //         type: 'warning'
                //     });
                //     return;
                // }
                this.$router.push('/consult');
            },
            appointment(num){
                if(this.userInfo.id == ''){
                    this.$message({
                        message: '请先登录',
                        type: 'warning'
                    });
                    return;
                }
                if(this.userInfo.role != 3){
                     this.$message({
                        message: '管理员无预约权限',
                        type: 'warning'
                    });
                    return;
                }
                this.$router.push({
                    name:'serviceList',
                    // path:'/serviceList',
                    query: {
                    type: num
                }
                });
            },
            getVido(){
                this.$axios
                    .post("/gw/training/top/1",{})
                    .then((res) => {
                        if(res.status == 200){
                            this.videoList = res.data.data.records;
                        }
                        // this.tableData = res.data.data.records;
                        // this.size = res.data.data.size;
                        // this.current = res.data.data.current;
                        // this.total = res.data.data.total;
                    });
            },
            openVideo(res){
                this.$router.push({
                    name:'consultDetail',
                    // path:'/serviceList',
                    query: res
                });
            },
            getTopNew(){
                this.$axios
                    .post("/gw/new/top/1",{})
                    .then((res) => {
                        this.topNews = res.data.data.records;
                        this.newsList = res.data.data.records;

                    });
            },
            getNew(){
                // this.$axios
                //     .get("/gw/new/top/1", {
                //         params: {
                //             // name: this.searchForm.name,
                //             // current: this.current,
                //             // size: this.size,
                //         },
                //     })
                //     .then((res) => {
                //         this.topNews = res.data.data.records;
                //
                //     });
            },
            message(res){
                this.$router.push({
                    // path: "/myCenter",
                    name: "myCenter",
                    query: {
                        type: res,
                        activeName: "fourth",
                    },
                });
            },
            openChart(){
                if(this.userInfo.id == ''){
                    this.$message({
                        message: '请先登录',
                        type: 'warning'
                    });
                    return;
                }
                this.showFlag = true;
            },
             getHomePage(){
                this.$axios
                    .post("/gw/organization/home/list",{})
                    .then((res) => {
                        if(res.status == 200){
                            let data = res.data.data;
                            for(let i=0;i<data.records.length;i++){
                                if(data.records[i].type == 1){  //居家服务数据
                                     this.homeData =data.records[i];  
                                     let  imgList = data.records[i].pictures.split(",");
                                    this.homeData.imgList = imgList;
                                }
                                if(data.records[i].type == 2){ //机构服务数据
                                     this.appointmenData =data.records[i];  
                                     let  imgList = data.records[i].pictures.split(",");
                                    this.appointmenData.imgList = imgList;
                                }
                                if(data.records[i].type == 3){ //适老化服务数据
                                     this.modificationData =data.records[i];  
                                     let  imgList = data.records[i].pictures.split(",");
                                    this.modificationData.imgList = imgList;
                                }
                                if(data.records[i].type == 4){ //床位服务数据
                                     this.bedData =data.records[i];  
                                     let  imgList = data.records[i].pictures.split(",");
                                    this.bedData.imgList = imgList;
                                }
                            }

                        }
                        // this.topNews = res.data.data.records;
                        // this.newsList = res.data.data.records;

                    });
            },
        },
    };
</script>

<style scoped>
    .box {
        position: relative;
        top: 0;
        left: 0;
        padding: 0;
        margin: auto;
        overflow: hidden;
    }
    .el-container {
        padding: 0;
        margin: 0;
        width: 100%;
        height: 100%;
    }
    /*.pic{*/
    /*    background: url("../assets/image/banner.jpg") no-repeat;*/
    /*    background-size:100% 100%;*/
    /*}*/
    .el-header {
        width: 100%;
        height: 5rem /* 115px -> 7.1875rem */ !important;
        line-height: 5rem /* 115px -> 7.1875rem */;
        background-color: #fff;
        color: #333;
        text-align: center;
        position: fixed;
        background: rgba(255, 255, 255, 0.8);
        top: 0;
        left: 0;
        z-index: 99 ;
    }

    .el-main {
        color: #333;
        padding: 0;
        width: 100%;
    }
    .pic {
        width: 100%;
        height: 42.8125rem /* 685px -> 42.8125rem */;
        /* margin: 15px 0; */
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #17b3a3;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
    }
    .tab {
        margin-top:1rem;
        background: #fff;
    }
    .tab-box {
        line-height: 100px;
        width: 100%;
    }
    .tab-box .el-button {
        border-radius: 1.5625rem /* 25px -> 1.5625rem */;
        width: 12%;
        margin: 0 1%;
        height: 2.4375rem /* 39px -> 2.4375rem */;
    }
    ::v-deep.pic .el-carousel__button {
        height: .625rem /* 10px -> .625rem */;
        width: .625rem /* 10px -> .625rem */;
        border-radius: 50%;
        /* background-color:#E6A23C ; */
    }
    ::v-deep .pic .el-carousel__indicator.is-active button {
        height: .625rem /* 10px -> .625rem */;
        background-color: #e6a23c;
    }
    .service {
        padding-top:2rem;
        width:100%;
        height: 59.375rem /* 950px -> 59.375rem */;
        overflow: hidden;
        /* background: #ccc; */
    }
    .service-title {
        height: 12.5rem /* 200px -> 12.5rem */;
        width: 12%;
        margin: 0 auto;
        text-align: center;
    }
    .service-pic {
        margin: 0 12.5rem /* 200px -> 12.5rem */;
    }
    ::v-deep .service-pic .el-carousel__indicators {
        display: none;
    }
    .service-content {
        width: 47.25rem /* 756px -> 47.25rem */;
        height: 5rem /* 80px -> 5rem */ /* 76px -> 4.75rem */;
        font-size: 1rem /* 16px -> 1rem */;
        letter-spacing: 2px;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        margin: 1.875rem /* 30px -> 1.875rem */ auto;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
    }
    .title-top {
        height: 6.25rem /* 100px -> 6.25rem */;
        line-height: 10.75rem /* 172px -> 10.75rem */;
        border-bottom: 2px solid #e6a23c;
        font-size: 1.5rem /* 24px -> 1.5rem */;
    }
    .title-bottom {
        height: 6.25rem /* 100px -> 6.25rem */;
        font-size: .5rem /* 8px -> .5rem */;
    }
    ::v-deep .appointment {
        width: 13.625rem /* 218px -> 13.625rem */;
        height: 4.125rem /* 66px -> 4.125rem */;
        background: linear-gradient(90deg, #ffb71d, #f77f00);
        box-shadow: 0px .3125rem /* 5px -> .3125rem */ 1.1875rem /* 19px -> 1.1875rem */ 11px rgba(224, 208, 159, 0.55);
        border-radius: .625rem /* 10px -> .625rem */;
        margin-left: 61.8125rem /* 989px -> 61.8125rem */;
    }

    .process {
        height: 33.125rem /* 530px -> 33.125rem */;
          width:100%;
        border-bottom: 2px solid #e6a23c;
    }
    .process-title {
        height: 6.25rem /* 100px -> 6.25rem */;
        line-height: 6.25rem /* 100px -> 6.25rem */;
        text-align: center;
    }

    .process-pic {
        float: left;
        width: 16% /* 300px -> 18.75rem */;
        height: 13.3125rem /* 213px -> 13.3125rem */;
        margin: 0 2% /* 25px -> 1.5625rem */;
    }
    .process-content {
        height:13.3125rem /* 213px -> 13.3125rem */;
        width:95% /* 1750px -> 109.375rem */;
        margin: 0 auto;
    }
    .process-line {
        float: left;
        width: 18.75rem /* 300px -> 18.75rem */;
        height: 6.25rem /* 100px -> 6.25rem */;
        margin: 0 1.5625rem /* 25px -> 1.5625rem */;
    }
    .process-bottom {
        margin: 0 4.375rem /* 70px -> 4.375rem */;
    }
    .line {
        width: .3125rem /* 5px -> .3125rem */;
        height: 100%;
        margin: 0 auto;
        background: #ccc;
        background: #e6a23c;
    }

    .yuan {
        width: 1.9375rem /* 31px -> 1.9375rem */;
        height: 1.9375rem /* 31px -> 1.9375rem */;
        margin: 0 auto;
        border-radius: 50%;
        background: #ccc;
        background: #e6a23c;
    }
    .isactive {
        background: #e6a23c;
    }
    .isactive-text {
        color: #e6a23c;
    }
    .process-text {
        text-align: center;
        color: #ccc;
        color: #e6a23c;
    }
    .home {
        padding-top:3rem;
        height: 65.5rem /* 1048px -> 65.5rem */;
    }
    .home-content {
        width: 82.1875rem /* 1315px -> 82.1875rem */;
        margin: 3.125rem /* 50px -> 3.125rem */ auto;
    }
    .home-left {
        float: left;
        width: 45.6875rem /* 731px -> 45.6875rem */;
        height: 19.125rem /* 306px -> 19.125rem */;
    }
    .home-text {
        width: 42.875rem /* 686px -> 42.875rem */;
        height: 6.6875rem /* 107px -> 6.6875rem */;
        margin: 5rem /* 80px -> 5rem */ auto;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 1.875rem /* 30px -> 1.875rem */;
    }
    .home-btn {
        width: 13.3125rem /* 213px -> 13.3125rem */;
        height: 4.125rem /* 66px -> 4.125rem */;
        background: linear-gradient(90deg, #ffb71d, #f77f00);
        box-shadow: 0px .3125rem /* 5px -> .3125rem */ 1.1875rem /* 19px -> 1.1875rem */ 1px rgba(224, 208, 159, 0.55);
        border-radius: .625rem /* 10px -> .625rem */;
        float: right;
        margin: 0 5rem /* 80px -> 5rem */;
    }
    .apply {
        padding-top:3rem;
        height: 34.6875rem /* 555px -> 34.6875rem */;
        overflow: hidden;
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
    .apply:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("../assets/image/bg5.jpeg") no-repeat;
        background-size: 100% 100%;
        background-color: #c1b8af;
        filter: blur(15px);
        z-index: -1;
    }
    .apply-btn {
        width: 13.625rem /* 218px -> 13.625rem */;
        height: 4.125rem /* 66px -> 4.125rem */;
        float: right;
        background: linear-gradient(90deg, #ffb71d, #f77f00);
        box-shadow: 0px .3125rem /* 5px -> .3125rem */ 1.1875rem /* 19px -> 1.1875rem */ 1px rgba(224, 208, 159, 0.55);
        border-radius: .625rem /* 10px -> .625rem */;
        margin-right: .625rem /* 10px -> .625rem */;
    }
    .apply-pic {
        width: 75rem /* 1200px -> 75rem */;
        height: 18.0625rem /* 289px -> 18.0625rem */;
        margin: 0 auto;
    }
    ::v-deep .apply-pic .el-carousel__indicators {
        display: none;
    }
    .bottom {
        margin-top: .8125rem /* 13px -> .8125rem */;
        line-height: .75rem /* 12px -> .75rem */;
    }
    .bed {
        padding-top:3rem;
        height: 68.9375rem /* 1103px -> 68.9375rem */;
        background: #ccc;
        overflow: hidden;
    }
    .bed-pic {
        width: 87.5rem /* 1400px -> 87.5rem */;
        height: 35.5rem /* 568px -> 35.5rem */;
        margin: 0 auto;
    }
    ::v-deep .bed-pic .el-carousel__indicators {
        display: none;
    }
    .bed-text {
        /* width: 1090px; */
        height: 5.625rem /* 90px -> 5.625rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        margin: 1.875rem /* 30px -> 1.875rem */ 28.125rem /* 450px -> 28.125rem */ 0 28.125rem /* 450px -> 28.125rem */;
    }
    .bed-btn {
        width: 13.625rem /* 218px -> 13.625rem */;
        height: 4.125rem /* 66px -> 4.125rem */;
        float: right;
        background: linear-gradient(90deg, #ffb71d, #f77f00);
        box-shadow: 0px .3125rem /* 5px -> .3125rem */ 1.1875rem /* 19px -> 1.1875rem */ 1px rgba(224, 208, 159, 0.55);
        border-radius: .625rem /* 10px -> .625rem */;
        margin-right: 25rem /* 400px -> 25rem */;
    }
    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both;
    }
    .provide {
        padding-top:3rem;
        overflow: hidden;
        height: 61.1875rem /* 979px -> 61.1875rem */;
        background: #ffffff;
    }
    .more-list {
        width: 10% /* 100px -> 6.25rem */;
        height: 1.875rem /* 30px -> 1.875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #f77f00;
        margin: 0 10% /* 278px -> 17.375rem */ 0 80% /* 1560px -> 97.5rem */;
    }
    .provide-content {
        width: 86.25rem /* 1380px -> 86.25rem */;
        height: 23.125rem /* 370px -> 23.125rem */;
        margin: 1.25rem /* 20px -> 1.25rem */ auto;
    }
    .provide-list {
        width: 26.875rem /* 430px -> 26.875rem */;
        height: 23.125rem /* 370px -> 23.125rem */;
        margin: 0 .625rem /* 10px -> .625rem */;
        float: left;
        border: 1px solid transparent;
    }
    .provide-list:hover {
        border: 1px solid #f77f00;
    }
    .provide-pic {
        width: 25.5rem /* 408px -> 25.5rem */;
        height: 13.9375rem /* 223px -> 13.9375rem */;
        margin: .9375rem /* 15px -> .9375rem */;
    }
    .provide-date {
        height: 1.875rem /* 30px -> 1.875rem */;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        margin: .9375rem /* 15px -> .9375rem */;
    }
    .provide-day {
        width: 2.6875rem /* 43px -> 2.6875rem */;
        height: .9375rem /* 15px -> .9375rem */;
        font-size: 1.25rem /* 20px -> 1.25rem */;
        font-family: Arial;
        font-weight: 400;
        color: #f77f00;
        float: left;
    }
    .provide-year {
        width:10rem /* 35px -> 2.1875rem */;
        height: .75rem /* 12px -> .75rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Arial;
        font-weight: 400;
        color: #f77f00;
        float: right;
    }
    .provide-title {
        width: 11.875rem /* 190px -> 11.875rem */;
        height: 2rem /* 32px -> 2rem */;
        font-size: .875rem /* 14px -> .875rem */;
        line-height: 2rem /* 32px -> 2rem */;
        font-family: Arial;
        font-weight: 400;
        color: #f77f00;
        text-align: left;
        margin: 0 .9375rem /* 15px -> .9375rem */;
    }
    .provide-text {
        width: 25rem /* 400px -> 25rem */;
        height: 2rem /* 32px -> 2rem */;
        font-size: .75rem /* 12px -> .75rem */;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #000000;
        line-height: 1.25rem /* 20px -> 1.25rem */;
        margin: 0 .9375rem /* 15px -> .9375rem */;
    }
    .provide-news {
        width: 87.5rem /* 1400px -> 87.5rem */;
        height: 25rem /* 400px -> 25rem */;
        margin: 3.125rem /* 50px -> 3.125rem */ auto;
    }
    .news-content {
        width: 87.5rem /* 1400px -> 87.5rem */;
        height: 5rem /* 80px -> 5rem */;
        border: 1px solid transparent;
    }
    .news-content:hover {
        background: #fdfbf5;
        color: #f77f00;
        border: 1px solid #f77f00;
    }
    .news-date {
        width: 25rem /* 400px -> 25rem */;
        height: 5rem /* 80px -> 5rem */;
        line-height: 80px;
        font-size: .75rem /* 12px -> .75rem */;
        font-family: Arial;
        font-weight: 400;
        float: left;
        text-align: center;
    }
    .news-text {
        width: 62.5rem /* 1000px -> 62.5rem */;
        height: 5rem /* 80px -> 5rem */;
        line-height: 5rem /* 80px -> 5rem */;
        float: left;
        text-align: center;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Arial;
        font-weight: 400;
    }
    .study {
        padding-top:3rem;
        height: 58.25rem /* 932px -> 58.25rem */;
        margin: 3.125rem /* 50px -> 3.125rem */;
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
    .study::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("../assets/image/bg7.jpeg") no-repeat;
        background-size: 100% 100%;
        filter: blur(15px);
        z-index: -1;
    }
    .more-study{
        width: 10% /* 100px -> 6.25rem */;
        height: 1.875rem /* 30px -> 1.875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        margin: 0 10% /* 278px -> 17.375rem */ 0 80% /* 1560px -> 97.5rem */;
    }
    .study-content {
        height: 31.25rem /* 500px -> 31.25rem */;
        width: 87.5rem /* 1400px -> 87.5rem */;
        margin: 1.875rem /* 30px -> 1.875rem */ auto;
    }
    .study-pic {
        width: 40.625rem /* 650px -> 40.625rem */;
        height: 15rem /* 240px -> 15rem */;
        margin: .625rem /* 10px -> .625rem */;
        float:left;
        border:1px solid transparent;
        background: #fff;
        position: relative;
        top: 0;
        left: 0;
        color: #000;
    }
    .study-date {
        position: absolute;
        bottom: 1.875rem /* 30px -> 1.875rem */;
        width: 40.625rem /* 650px -> 40.625rem */;
        height: 1.875rem /* 30px -> 1.875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 600;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        opacity: 0.8;
    }
    .study-title {
        position: absolute;
        bottom: 0;
        width: 40.625rem /* 650px -> 40.625rem */;
        height: 1.875rem /* 30px -> 1.875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 600;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        opacity: 0.8;
    }
    .study-pic:hover {
        color: #f77f00;
        border: 1px solid #f77f00;
    }
    .advantages{
        padding-top:3rem;
        height:56.25rem /* 900px -> 56.25rem */;
        overflow: hidden;
        width: 100%;
    }
    .advantages-content{
        height:28.125rem /* 450px -> 28.125rem */;
        width:90%;
        margin:3.125rem /* 50px -> 3.125rem */ auto;
    }
    .advantages-pic{
        width: 16% /* 320px -> 20rem */;
        height: 28.125rem /* 450px -> 28.125rem */;
        margin: .625rem 1.9%/* 10px -> .625rem */;
        float:left;
        border:1px solid transparent;
        position: relative;
        top: 0;
        left: 0;
        color: #000;
    }
    .advantages-box{
        width:100%;
        height:150px;
    }
    .advantages-title{
        height: 3.125rem /* 50px -> 3.125rem */;
        font-size: 1.125rem /* 18px -> 1.125rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 3.125rem /* 50px -> 3.125rem */;
        color: #000000;
        text-align: center;
    }
    .advantages-text{
        width:80%;
        margin:0 10%;
        height: 2.75rem /* 44px -> 2.75rem */;
        font-size: .875rem /* 14px -> .875rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C1B8AF;
        line-height: 1.875rem /* 30px -> 1.875rem */;
    }
    .advantages-pic:hover{
        background: #f77f00;
    }
    .advantages-pic:hover .advantages-text{
        color: #fff;
    }
    .advantages-pic:hover .advantages-title{
        color: #fff;
    }
    .menu {
        width: 5.125rem /* 82px -> 5.125rem */;
        height: 18.75rem /* 300px -> 18.75rem */;
        right: 12.5rem /* 200px -> 12.5rem */;
        top: 31.25rem /* 500px -> 31.25rem */;
        position: fixed;
        z-index: 999;
    }
    .menu ul {
        width: 5.125rem /* 82px -> 5.125rem */;
        height: 18.75rem /* 300px -> 18.75rem */;
        padding: 0;
        display: block;
    }
    .menu-item-service {
        margin-top: .25rem /* 4px -> .25rem */;
        height: 4.0625rem /* 65px -> 4.0625rem */;
        line-height: 4.0625rem /* 65px -> 4.0625rem */;
        font-size: .8125rem /* 13px -> .8125rem */;
        text-align: center;
        width: 100%;
        display: block;
        background: url('../assets/image/service.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-service:hover{
        background: url('../assets/image/service_g.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-tel {
        margin-top: .25rem /* 4px -> .25rem */;
        height: 4.0625rem /* 65px -> 4.0625rem */;
        line-height: 4.0625rem /* 65px -> 4.0625rem */;
        font-size: .8125rem /* 13px -> .8125rem */;
        text-align: center;
        width: 100%;
        display: block;
        background: url('../assets/image/tel.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-tel:hover{
        background: url('../assets/image/tel_g.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-wechat {
        margin-top: .25rem /* 4px -> .25rem */;
        height: 4.0625rem /* 65px -> 4.0625rem */;
        line-height: 4.0625rem /* 65px -> 4.0625rem */;
        font-size: .8125rem /* 13px -> .8125rem */;
        text-align: center;
        width: 100%;
        display: block;
        background: url('../assets/image/wechat.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-wechat:hover{
        background: url('../assets/image/wechat_g.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-message {
        margin-top: .25rem /* 4px -> .25rem */;
        height: 4.0625rem /* 65px -> 4.0625rem */;
        line-height: 4.0625rem /* 65px -> 4.0625rem */;
        font-size: .8125rem /* 13px -> .8125rem */;
        text-align: center;
        width: 100%;
        display: block;
        background: url('../assets/image/message.png') no-repeat;
        background-size: 80% 80%;
    }
    .menu-item-message:hover{
        background: url('../assets/image/message_g.png') no-repeat ;
        background-size: 80% 80%;
    }
    a {
        text-decoration: none;
    }
    .public{
        width:12%; /* 268px -> 16.75rem */;
        height:9.6875rem /* 155px -> 9.6875rem */;
        margin:0 1.14%;
        float:left;
        box-shadow: 0px .5rem /* 8px -> .5rem */ 1.125rem /* 18px -> 1.125rem */ 2px rgba(224, 208, 159, 0.35);
    }
    .jjyl-text{
        text-align: center;
        width:100%;
        line-height: 1.125rem /* 18px -> 1.125rem */;
        font-size: 1.125rem /* 18px -> 1.125rem */;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C1B8AF;
    }
    .public>.jjyl-pic{
        width:3rem /* 48px -> 3rem */;
        height:3rem /* 48px -> 3rem */;
        margin:1.3125rem /* 21px -> 1.3125rem */ auto /* 112px -> 7rem */;
        background-size: 100% 100%;
    }
    .jjyl>.jjyl-pic{
        background: url('../assets/image/jjyl.png') no-repeat;
        background-size: 100% 100%;
    }
    .jjyl:hover .jjyl-pic{
        background: url('../assets/image/jjyl_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .jjyl:hover .jjyl-text{
        color: #000101;
    }
    .yljg>.jjyl-pic {
        background: url('../assets/image/yljg.png') no-repeat;
        background-size: 100% 100%;
    }
    .yljg:hover .jjyl-pic{
        background: url('../assets/image/yljg_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .yljg:hover .jjyl-text{
        color: #000101;
    }
    .gzsq>.jjyl-pic{
        background: url('../assets/image/gzsq.png') no-repeat;
        background-size: 100% 100%;
    }
    .gzsq:hover .jjyl-pic{
        background: url('../assets/image/gzsq_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .gzsq:hover .jjyl-text{
        color: #000101;
    }
    .jtcw>.jjyl-pic {
        background: url('../assets/image/jtcw.png') no-repeat;
        background-size: 100% 100%;
    }
    .jtcw:hover .jjyl-pic{
        background: url('../assets/image/jtcw_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .jtcw:hover .jjyl-text{
        color: #000101;
    }
    .ylzx>.jjyl-pic{
        background: url('../assets/image/ylzx.png') no-repeat;
        background-size: 100% 100%;
    }
    .ylzx:hover .jjyl-pic{
        background: url('../assets/image/ylzx_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .ylzx:hover .jjyl-text{
        color: #000101;
    }
    .pxxx>.jjyl-pic{
        background: url('../assets/image/pxxx.png') no-repeat;
        background-size: 100% 100%;
    }
    .pxxx:hover .jjyl-pic{
        background: url('../assets/image/pxxx_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .pxxx:hover .jjyl-text{
        color: #000101;
    }
    .zyz>.jjyl-pic{
        background: url('../assets/image/zyz.png') no-repeat;
        background-size: 100% 100%;
    }
    .zyz:hover .jjyl-pic{
        background: url('../assets/image/zyz_g.png') no-repeat;
        background-size: 100% 100%;
    }
    .zyz:hover .jjyl-text{
        color: #000101;
    }
</style>
